/**
 * Radial dimensions used by LVGL 7's lv_draw_arc().
 *
 * LVGL clamps the line width to the supplied outer radius and uses C integer
 * division for rounded endpoint geometry.
 */
export function lvglArcStrokeGeometry({ radius = 0, lineWidth = 0 } = {}) {
    const outerRadius = Math.max(0, Math.trunc(Number(radius) || 0));
    const requestedWidth = Math.max(0, Math.trunc(Number(lineWidth) || 0));
    const width = Math.min(requestedWidth, outerRadius);
    const thickHalf = Math.trunc(width / 2);

    return {
        outerRadius,
        lineWidth: width,
        thickHalf,
        innerRadius: outerRadius - width,
        capRadius: thickHalf,
        capCenterRadius: outerRadius - thickHalf,
    };
}
